var map = {
	"./img1_tablet@2x.webp": 3357,
	"./img2_tablet@2x.webp": 8232,
	"./img3_tablet@2x.webp": 6931,
	"./img4_tablet@2x.webp": 5830,
	"./img5_tablet@2x.webp": 6385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5350;